import {
  ClippedImageWrapper,
  LabelText,
  SectionContainer,
  StyledImage,
  StyledVideo,
  TextWrapper,
  TitleText,
  TitleWrapper,
  VideoOverlay,
} from './styles';
import Button from '@components/Button';
import { Row } from '@components/LinearLayout';
import { useMobileWidth } from '@utils/hooks';
import { useTheme } from 'styled-components';

interface HeroSectionWithRotatedImageProps {
  backgroundImageURL?: string;
  backgroundVideoURL?: string;
  buttonText?: string;
  buttonText2?: string;
  isButton2Outlined?: boolean;
  isButton2Mobile?: boolean;
  buttonURL?: string;
  button2URL?: string;
  buttonScrollTo?: string;
  button2ScrollTo?: string;
  label?: string;
  textColor?: string;
  titleStart: string;
  titleBlue?: string;
  titleBlueBreak?: boolean;
  titleEnd?: string;
  titleEndBlue?: string;
  secondTitleStart?: string;
  secondTitleBlue?: string;
  secondTitleEnd?: string;
  videoOverlay?: boolean;
  extraPadding?: boolean;
  hasNoCenter?: boolean;
}

const HeroSectionWithRotatedImage = ({
  backgroundImageURL,
  backgroundVideoURL,
  buttonText,
  buttonText2,
  isButton2Outlined,
  isButton2Mobile,
  buttonURL,
  button2URL,
  buttonScrollTo,
  button2ScrollTo,
  label,
  textColor,
  titleStart,
  titleBlue,
  titleBlueBreak,
  titleEnd,
  titleEndBlue,
  secondTitleStart,
  secondTitleBlue,
  secondTitleEnd,
  videoOverlay,
  extraPadding,
  hasNoCenter,
}: HeroSectionWithRotatedImageProps) => {
  const theme = useTheme();
  const isMobile = useMobileWidth();

  const handleScrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <SectionContainer $hasNoCenter={hasNoCenter}>
      <TextWrapper $extraPadding={extraPadding} $hasNoCenter={hasNoCenter}>
        <LabelText>{label}</LabelText>

        <TitleWrapper noMarginBottom={!!secondTitleStart}>
          <TitleText>{titleStart}</TitleText>
          {titleBlueBreak && <br />}
          <TitleText color={theme.color.mobilityBlue}> {titleBlue} </TitleText>
          <TitleText>{titleEnd}</TitleText>
          <TitleText color={theme.color.mobilityBlue}>{titleEndBlue}</TitleText>
        </TitleWrapper>

        {secondTitleStart && (
          <TitleWrapper>
            <TitleText>{secondTitleStart}</TitleText>
            <TitleText color={theme.color.mobilityBlue}>
              {' '}
              {secondTitleBlue}{' '}
            </TitleText>
            <TitleText>{secondTitleEnd}</TitleText>
          </TitleWrapper>
        )}

        <Row $gap={isMobile ? '1rem' : '3rem'}>
          {buttonText && (
            <Button
              title={buttonText}
              backgroundColor={theme.color.mobilityBlue}
              hoverBackgroundColor={theme.color.mobilityGrey}
              textColor={theme.color.white}
              borderRadius={isMobile ? '0.5rem' : theme.borderRadius.radius10}
              padding={isMobile ? '1.5rem 2rem' : '1.5rem 5.5rem'}
              width={isMobile ? '100%' : 'max-content'}
              onClick={() => {
                if (buttonScrollTo) {
                  handleScrollTo(buttonScrollTo);
                } else if (buttonURL) {
                  window.location.href = buttonURL;
                }
              }}
            />
          )}

          {buttonText2 && !isButton2Mobile && (
            <Button
              title={buttonText2}
              backgroundColor={
                isButton2Outlined ? 'transparent' : theme.color.mobilityBlue
              }
              hoverBackgroundColor={theme.color.mobilityGrey}
              textColor={
                isButton2Outlined ? theme.color.mobilityBlue : theme.color.white
              }
              border={
                isButton2Outlined
                  ? `2px solid ${theme.color.mobilityBlue}`
                  : 'none'
              }
              borderRadius={isMobile ? '0.5rem' : theme.borderRadius.radius10}
              padding={isMobile ? '1.5rem 2rem' : '1.5rem 5.5rem'}
              width={isMobile ? '100%' : 'max-content'}
              onClick={() => {
                if (button2ScrollTo) {
                  handleScrollTo(button2ScrollTo);
                } else if (button2URL) {
                  window.open(`${button2URL}`, '_blank', 'noopener,noreferrer');
                }
              }}
            />
          )}
        </Row>
      </TextWrapper>

      {backgroundImageURL && (
        <ClippedImageWrapper>
          <StyledImage src={backgroundImageURL} alt="career-hero-section" />
        </ClippedImageWrapper>
      )}
      {backgroundVideoURL && (
        <ClippedImageWrapper>
          <StyledVideo
            src={backgroundVideoURL}
            autoPlay
            muted
            playsInline
            loop
          />
          {videoOverlay && <VideoOverlay />}
        </ClippedImageWrapper>
      )}
    </SectionContainer>
  );
};

export default HeroSectionWithRotatedImage;
